import Style from "./style";

export default function DetailsList({ config = [] }) {
  return (
    <Style>
      <div className="table" style={{ marginBottom: 0 }}>
        {config.map((conf, i) => (
          <div className="item" key={`item-${conf.key}-${i}`}>
            {conf.img ? (
              <img alt="img" src={conf.img} />
            ) : null}
            <h2 className="main">{conf.title}</h2>
            <h2 className="bold">
              {typeof conf.render === 'function' ? conf.render() : null}
            </h2>
          </div>
        ))}
      </div>
    </Style>
  );
}
